import { NgModule } from '@angular/core';
import { AutofocusDirective } from '@flipto/shared/src/lib/directives/accessibility/autofocus.directive';
import { BackgroundImageDirective } from '@flipto/shared/src/lib/directives/image/background-image.directive';
import { FitTextDirective } from '@flipto/shared/src/lib/directives/text/fit-text.directive';
import { DelayedClassDirective } from '@flipto/shared/src/lib/directives/effects/delayed-class.directive';
import { StreamEmbedDirective } from '@flipto/shared/src/lib/directives/stream/stream-embed.directive';
import { ElementSizeDirective } from '@flipto/shared/src/lib/directives/observers/element-size.directive';
import { ParallaxDirective } from '@flipto/shared/src/lib/directives/effects/parallax-bg.directive';
import { ImageExistCheckDirective } from '@flipto/shared/src/lib/directives/image/image-exist-check.directive';

@NgModule({
    imports: [
        AutofocusDirective,
        BackgroundImageDirective,
        ImageExistCheckDirective,
        FitTextDirective,
        DelayedClassDirective,
        StreamEmbedDirective,
        ElementSizeDirective,
        ParallaxDirective,
    ],
    exports: [
        AutofocusDirective,
        BackgroundImageDirective,
        ImageExistCheckDirective,
        FitTextDirective,
        DelayedClassDirective,
        StreamEmbedDirective,
        ElementSizeDirective,
        ParallaxDirective,
    ]
})
export class SharedDirectivesModule {
}
